var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 122 122"}},[_c('circle',{attrs:{"cx":"61","cy":"61","r":"60","fill":"#FFF"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#3E2B2E","d":"M86.157 62.23a.75.75 0 0 1 0 1.29L47.132 86.582A.75.75 0 0 1 46 85.936V39.814a.75.75 0 0 1 1.132-.645l39.025 23.06Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }